import { TutorialDefinition } from "../types";

const tour: TutorialDefinition = {
  id: "add-to-report",
  version: "1.0.0",
  releasedAt: "2026-04-09T00:00:00.000Z",
  category: "new-feature",
  title: "Add to Report",
  description:
    "Use voice to fill in details for the AI suggestions on your report.",
  // Only fire on a specific case page (/cases/<id>), not the empty /cases list.
  triggerRoute: /^\/cases\/[^/]+$/,
  autoStart: true,
  steps: [
    {
      // Anchored on the first suggestion list item — this element only exists
      // when the case has loaded AND has suggestions, so the tutorial is
      // naturally gated to "case with suggestions".
      target: '[data-tour="suggestion-item"]',
      title: "AI Suggestions",
      content:
        "These are AI-generated suggestions for details that may be missing from your report. Each suggestion highlights information that could help make your narrative more complete.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: '[data-tour="add-to-report-button"]',
      title: "Add to Report",
      content:
        "Click here to record or upload audio. Address any suggestions, placeholders, or add additional context, and the AI will intelligently incorporate the new details into your report.",
      placement: "left",
    },
  ],
};

export default tour;
